import { HTTP_METHOD } from "../../../helper/constants";
import request from "../../request";

const hoFilterApi = {
  // A1 — all categories.
  getHoCategories: () => {
    const url = "quickapp/v1/lead-store-mapping/category";
    return request({
      method: HTTP_METHOD.GET,
      url,
      useBaseUrl2: true,
    });
  },

  // A2 — businesses, optionally scoped to a category. Omit `category` for all.
  getHoBusinesses: (category) => {
    const url = category
      ? `quickapp/v1/lead-store-mapping/business/byCategory?category=${encodeURIComponent(
          category
        )}`
      : "quickapp/v1/lead-store-mapping/business/byCategory";
    return request({
      method: HTTP_METHOD.GET,
      url,
      useBaseUrl2: true,
    });
  },
};

export default hoFilterApi;
